export default "__VITE_ASSET__9ad5ad6a__"